<template>
    <div class="wrapper">
        <div class="main-panel">
            <div class="main-content">
                <div class="content-wrapper">
                    <div class="container-fluid">
                      <div class="row">
                        <div class="col-md-12">
                          <a class="btn btn-secondary float-right top-back-button" @click.prevent="back()"><i class="fa fa-arrow-left"></i></a>
                        </div>
                      </div>
                        <div class="row">
                           <div class="col-md-8 offset-md-2">
                                <div class="card">
                                    <div class="card-body" >
                                        <div v-if="article._id">
                                            <h2>{{ article.title }}</h2>
                                            <p class="published">
                                                <i class="ft-calendar font-medium-3"></i> 
                                                {{ formatDate(article.publishedAt) }}    
                                            </p>
                                            <figure v-if="article.image.signed_url">
                                                <img :src="article.image.signed_url" :alt="article.title">
                                            </figure>
                                            <div class="article-body" v-html="article.body">

                                            </div>
                                            <hr />
                                            <div class="row">
                                                <div class="col-md-4">
                                                    <table class="articleRating">
                                                    <tr>
                                                        <td class="positive">
                                                            {{ good }}
                                                        </td>
                                                        <td class="neutral">
                                                            {{ neutral }}
                                                        </td>
                                                        <td class="bad">
                                                            {{ bad }}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <a href="#" @click.prevent="vote('good')">
                                                                <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                                                    viewBox="0 0 567.419 567.419" class="positive" xml:space="preserve">
                                                                    <g>
                                                                        <g>
                                                                            <g id="group-2svg">
                                                                                <path id="path-1_10_" d="M409.93,209.297c0,18.056-14.627,32.692-32.683,32.692c-18.047,0-32.683-14.636-32.683-32.692
                                                                                    s14.636-32.683,32.683-32.683C395.303,176.614,409.93,191.241,409.93,209.297z"/>
                                                                                <path id="path-2_10_" d="M222.011,209.297c0,18.056-14.636,32.692-32.683,32.692s-32.683-14.636-32.683-32.692
                                                                                    s14.636-32.683,32.683-32.683S222.011,191.241,222.011,209.297z"/>
                                                                                <path id="path-3_10_" d="M308.702,451.466h-45.388c-57.483,0-104.253-46.205-104.253-103.014c0-7.443,6.034-13.468,13.468-13.468
                                                                                    c7.434,0,13.468,6.025,13.468,13.468c0,42.659,33.958,76.078,77.317,76.078h45.388c43.359,0,77.317-32.863,77.317-74.821
                                                                                    c0-7.443,6.034-13.468,13.468-13.468c7.443,0,13.468,6.025,13.468,13.468C412.956,406.769,367.163,451.466,308.702,451.466z"/>
                                                                                <path id="path-4_10_" d="M283.714,567.419c-156.403,0-283.642-127.275-283.642-283.714C0.072,127.275,127.311,0,283.714,0
                                                                                    c156.394,0,283.633,127.275,283.633,283.705C567.347,440.143,440.108,567.419,283.714,567.419z M283.714,26.946
                                                                                    c-141.552,0-256.705,115.181-256.705,256.759c0,141.588,115.154,256.768,256.705,256.768
                                                                                    c141.543,0,256.696-115.181,256.696-256.768C540.41,142.126,425.257,26.946,283.714,26.946z"/>
                                                                            </g>
                                                                        </g>
                                                                    </g>
                                                                </svg>
                                                            </a>
                                                        </td>
                                                        <td>
                                                            <a href="" @click.prevent="vote('neutral')">
                                                                <svg viewBox="0 0 448 448" class="neutral" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="m224 448c-123.464844 0-224-100.535156-224-224s100.535156-224 224-224 224 100.535156 224 224-100.535156 224-224 224zm0-426.667969c-111.734375 0-202.667969 90.933594-202.667969 202.667969s90.933594 202.667969 202.667969 202.667969 202.667969-90.933594 202.667969-202.667969-90.933594-202.667969-202.667969-202.667969zm0 0"/>
                                                                    <path d="m106.667969 288h234.664062v21.332031h-234.664062zm0 0"/>
                                                                    <path d="m298.667969 202.667969c-23.566407 0-42.667969-19.105469-42.667969-42.667969s19.101562-42.667969 42.667969-42.667969c23.5625 0 42.664062 19.105469 42.664062 42.667969s-19.101562 42.667969-42.664062 42.667969zm0-64c-11.785157 0-21.335938 9.550781-21.335938 21.332031s9.550781 21.332031 21.335938 21.332031c11.78125 0 21.332031-9.550781 21.332031-21.332031s-9.550781-21.332031-21.332031-21.332031zm0 0"/>
                                                                    <path d="m149.332031 202.667969c-23.5625 0-42.664062-19.105469-42.664062-42.667969s19.101562-42.667969 42.664062-42.667969c23.566407 0 42.667969 19.105469 42.667969 42.667969s-19.101562 42.667969-42.667969 42.667969zm0-64c-11.78125 0-21.332031 9.550781-21.332031 21.332031s9.550781 21.332031 21.332031 21.332031c11.785157 0 21.335938-9.550781 21.335938-21.332031s-9.550781-21.332031-21.335938-21.332031zm0 0"/>
                                                                </svg>
                                                            </a>
                                                        </td>
                                                        <td>
                                                            <a href="" @click.prevent="vote('bad')">
                                                                <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                                                    viewBox="0 0 567.419 567.419" class="bad" xml:space="preserve">
                                                                    <g>
                                                                        <g>
                                                                            <g id="group-3svg">
                                                                                <path id="path-1_21_" d="M409.93,209.297c0,18.056-14.627,32.692-32.683,32.692c-18.047,0-32.683-14.636-32.683-32.692
                                                                                    s14.636-32.683,32.683-32.683C395.303,176.614,409.93,191.241,409.93,209.297z"/>
                                                                                <path id="path-2_21_" d="M222.011,209.297c0,18.056-14.636,32.692-32.683,32.692s-32.683-14.636-32.683-32.692
                                                                                    s14.636-32.683,32.683-32.683S222.011,191.241,222.011,209.297z"/>
                                                                                <path id="path-3_21_" d="M172.538,453.621c-7.434,0-13.468-6.025-13.468-13.468c0-58.138,46.762-105.439,104.245-105.439h45.397
                                                                                    c57.483,0,104.245,47.04,104.245,104.855c0,7.443-6.025,13.477-13.468,13.477c-7.435,0-13.459-6.034-13.459-13.477
                                                                                    c0-42.955-34.685-77.91-77.317-77.91h-45.397c-42.632,0-77.308,35.206-77.308,78.493
                                                                                    C186.006,447.596,179.972,453.621,172.538,453.621z"/>
                                                                                <path id="path-4_21_" d="M283.714,567.419c-156.403,0-283.642-127.275-283.642-283.714C0.072,127.275,127.311,0,283.714,0
                                                                                    c156.394,0,283.633,127.275,283.633,283.705C567.347,440.143,440.108,567.419,283.714,567.419z M283.714,26.946
                                                                                    c-141.552,0-256.705,115.181-256.705,256.759c0,141.588,115.154,256.768,256.705,256.768
                                                                                    c141.543,0,256.696-115.181,256.696-256.768C540.41,142.126,425.257,26.946,283.714,26.946z"/>
                                                                            </g>
                                                                        </g>
                                                                    </g>
                                                                </svg>
                                                            </a>
                                                        </td>
                                                    </tr>
                                                </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
     </div>
</template>

<script>
import NewsService from '@/services/news'
import moment from 'moment'

export default {
    data() {
        return {
            article: {}
        }
    },
    computed: {
        good() {
            if (this.article.votes) {
                if (this.article.votes.length > 0) {
                    let goodVotes = this.article.votes.filter(function(vt){
                       return vt.rating === 'good'
                    })
                    return goodVotes.length
                } else {
                    return 0
                }
            } else {
                return 0
            }
        },
        neutral() {
            if (this.article.votes) {
                if (this.article.votes.length > 0) {
                     let neutralVotes = this.article.votes.filter(function(vt){
                       return vt.rating === 'neutral'
                    })
                    return neutralVotes.length
                } else {
                    return 0
                }
            } else {
                return 0
            }
        },
        bad() {
            if (this.article.votes) {
                if (this.article.votes.length > 0) {
                    let badVotes = this.article.votes.filter(function(vt){
                       return vt.rating === 'bad'
                    })
                    return badVotes.length
                } else {
                    return 0
                }
            } else {
                return 0
            }
        }
    },
    methods: {
      back() {
        this.$router.push({ name: 'publicNews'})
      },
        formatDate(d) {
            return moment(new Date(d)).format("YYYY-MM-DD")
        },
        vote: async function (userVote) {
            let currentUserVotes = this.article.votes
            if (this.article.votes && this.article.votes.length > 0) {
                let currentUserId = this.$store.state.user._id
                currentUserVotes = this.article.votes.filter(function(vt){
                    return vt.userId === currentUserId
                })
            }
            if (currentUserVotes.length === 0) {
                let ratingItem = { userId: this.$store.state.user._id, rating: userVote }
                this.article.votes.unshift(ratingItem)
                let formData = new FormData()
                formData.append('article', JSON.stringify(this.article))
                let result = await NewsService.update(formData)
                if (result) {
                    this.$miniToastr.success(this.$t("flash.voteSuccess"))
                }
            } else {
                this.$miniToastr.error(this.$t("flash.alreadyVoted"))
            }
        }
    },
    mounted: async function() {
        let result = await NewsService.bySlug(this.$route.params.slug)
        if (result) {
            this.article = result.data
        }
    }
}
</script>

<style lang="scss">
    h2 {
        padding: 25px 15px 0 15px;
    }

    img {
        max-width: 100%;
    }

    .article-body {
        padding: 15px;
    }

    .published {
        padding: 0 0 15px 15px;
    }

    .articleRating {
        width: 100%;
        margin-bottom: 15px;

        td {
            text-align: center;
            font-weight: bold;
        }
    }

    svg {
        width: 36px;
        fill: #ccc;
        transition: all .5s ease;
    }

    .positive {
        color: green;
        &:hover {
            fill: green;
        }
    }

    .neutral {
        color: orange;
        &:hover {
            fill: orange;
        }
    }

    .bad {
        color: red;
        &:hover {
            fill: red;
        }
    }
</style>


